export default __webpack_public_path__ + "345c6414ab5d4de8e31873bb81b7bec7.mp4";